import React from 'react';
import s from './footer.module.sass'

const Footer = () => {
    return (
        <footer className={s.footer}>
            Copyright 2025 &#169; Milino LLC
        </footer>
    );
};

export default Footer;